var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2.5H3C2.30964 2.5 1.75 3.05964 1.75 3.75V13.75C1.75 14.4404 2.30964 15 3 15H18C18.6904 15 19.25 14.4404 19.25 13.75V3.75C19.25 3.05964 18.6904 2.5 18 2.5Z",
    stroke: "inherit",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 17.5L12.0625 15H8.9375L8.625 17.5H12.375Z",
    fill: "inherit",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.875 17.5H6.125",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 11.875V13.75C1.75093 14.0812 1.88292 14.3986 2.11714 14.6329C2.35136 14.8671 2.66876 14.9991 3 15H18C18.3312 14.9991 18.6486 14.8671 18.8829 14.6329C19.1171 14.3986 19.2491 14.0812 19.25 13.75V11.875H1.75ZM10.5 14.375C10.3764 14.375 10.2555 14.3383 10.1528 14.2697C10.05 14.201 9.96988 14.1034 9.92257 13.9892C9.87527 13.875 9.86289 13.7493 9.88701 13.6281C9.91113 13.5068 9.97065 13.3955 10.0581 13.3081C10.1455 13.2206 10.2568 13.1611 10.3781 13.137C10.4993 13.1129 10.625 13.1253 10.7392 13.1726C10.8534 13.2199 10.951 13.3 11.0197 13.4028C11.0883 13.5055 11.125 13.6264 11.125 13.75C11.125 13.9158 11.0592 14.0747 10.9419 14.1919C10.8247 14.3092 10.6658 14.375 10.5 14.375Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.85700573d6fc8fbb8e78db833b1ccbe5.svg";
export { ForwardRef as ReactComponent };